import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledProjectWarningMissingBanner = styled(Flexbox)<{$variant?: 'warning' | 'error'}>(
    ({theme: {spacing, palette}, $variant = 'warning'}) => css`
        background-color: ${$variant == 'warning' ? palette.orange['100'] : palette.danger['100']};
        padding: ${spacing * 2}px;
        border-radius: 8px;

        & b {
            font-weight: 500;
        }

        & svg {
            width: 14px;
            height: 14px;
            color: ${$variant == 'warning' ? palette.orange['500'] : palette.danger['500']};
        }
    `
)
